import jiameiLogo from './label_logo/jiamei.jpg';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

const generateBarcodes = async (expressNumber, orderNumber) => {
  const createBarcode = (text, options) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('style', 'background: white;');
    
    try {
      JsBarcode(svg, text, {
        format: 'CODE128',
        xmlDocument: document,
        ...options,
        background: '#FFFFFF',
        lineColor: '#000000',
      });
    } catch (error) {
      console.error('Barcode generation error:', error);
      return '';
    }
    
    return svg.outerHTML;
  };

  // Generate top barcode
  const topBarcode = createBarcode(expressNumber || orderNumber, {
    width: 1.72, // 
    height: 50,
    displayValue: true,
    fontSize: 12, // Slightly reduced font size
    textMargin: 4,
    margin: 5,
  });

  // Generate bottom barcode
  const bottomBarcode = createBarcode(expressNumber, {
    width: 2.22,  // 
    height: 55,  // Slightly increased height to maintain proportions
    displayValue: true,
    fontSize: 14,
    textMargin: 1,
    margin: 1,
  });

  // Generate QR code
  let qrDataUrl = '';
  try {
    qrDataUrl = await QRCode.toDataURL(expressNumber || orderNumber, {
      width: 130,
      margin: 1,
      errorCorrectionLevel: 'M',
      scale: 3.5,
    });
  } catch (error) {
    console.error('QR code generation error:', error);
    throw error;
  }

  return {
    topBarcode: `<div style="width: 100%; height: 100%; background: white;">${topBarcode}</div>`,
    bottomBarcode: bottomBarcode,
    qrCode: `<img src="${qrDataUrl}" style="width: 85px; height: 85px;" />`, // Smaller QR code
  };
};


const generateLabel = async (item) => {
  try {
    const { topBarcode, bottomBarcode, qrCode } = await generateBarcodes(item.express_number, item.order_number);
    if (!topBarcode || !bottomBarcode || !qrCode) {
      console.error('Failed to generate one or more barcodes');
      return null;
    }

    return `
    <style>
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        @page {
          size: auto;
          margin: 0mm;
        }
      }
    </style>
    <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; border: 2px solid #000; padding: 8px; box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; zoom: 1;">
      <!-- 大头笔 Section -->
      <div style="margin-bottom: 1px;">
        <div style="font-size: 16px; font-weight: bold; text-align: center; padding: 1px;">
          421- 17 007,苏州转
        </div>
      </div>

      <!-- Header Section -->
      <div style="margin-bottom: 0px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2px;">
          <!-- Logo and Barcode -->
          <div style="display: flex; align-items: center; flex-grow: 1;">
            <img src="${jiameiLogo}" style="width: 75px; height: auto; margin-right: 3px;" />
            <div style="flex-grow: 1;">
              <div style="font-size: 11px; font-weight: bold; white-space: nowrap; padding-top: 8px; margin-left: 5px;">运单编号 / Tracking No.</div>
              <div style="display: flex; align-items: center;">
                <div style="max-width: 70%;">${topBarcode}</div>
                <div style="margin-left: 8px; display: flex; flex-direction: column; align-items: center; width: 75px;">
                  <div style="font-size: 16px; font-weight: bold; margin-top: -18px;">集包地</div>
                  <div style="font-size: 7px; color: #666; margin-top: -1px; letter-spacing: -0.2px;">DISTRIBUTE TO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipper Info Section -->
      <div style="border: 1px solid #000; margin-bottom: 3px; display: table; width: 100%;">
        <div style="display: table-row;">
          <div style="display: table-cell; width: 25%; padding: 3px; font-weight: bold; font-size: 12px; border-right: 1px solid #000; vertical-align: top;">
            <span style="font-weight: bold;">发货人信息</span><br/>SHIPPER INFO.
          </div>
          <div style="display: table-cell; padding: 3px; font-size: 9px; line-height: 1.1; font-weight: 500;">
            发货人/SHIPPER: ${item.sender_name || 'Coolala Boutique'}<br/>
            电话/TEL: ${item.sender_phone || '4168766068'}<br/>
            地址/ADDRESS: ${item.sender_address || 'Markham, CANADA'}<br/>
            退件地址/PACKAGE RETURNING ADDRESS:
          </div>
        </div>
      </div>

      <!-- Receiver Info Section -->
      <div style="border: 1px solid #000; margin-bottom: 6px; display: table; width: 100%;">
        <div style="display: table-row;">
          <div style="display: table-cell; width: 25%; padding: 3px; font-weight: bold; font-size: 12px; border-right: 1px solid #000; vertical-align: top;">
            <span style="font-weight: bold;">收件人信息</span><br/>RECEIVER INFO.
          </div>
          <div style="display: table-cell; padding: 3px; font-size: 9px; line-height: 1.1; font-weight: 500;">
            收件人/TO: ${item.label_address ? item.label_recipient : item.recipient_name}<br/>
            电话/TEL: ${item.label_address ? item.label_phone : (item.recipient_phone || '-')}<br/>
            地址/ADDRESS: ${item.label_address ? item.label_address : (item.recipient_address || '-')}
          </div>
        </div>
      </div>

      <!-- Delivery Acknowledgment Section -->
      <div style="border: 1px solid #000; margin-bottom: 6px; padding: 6px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="flex-grow: 1; font-size: 8.5px; color: #000; line-height: 1.1; padding-right: 5px; border-right: 1px solid #000; font-weight: 500;">
            快件送到收件人地址，经收件人或收件人（寄件人）允许的代收人签名，视为送达。您的签字代表您已验收此包裹，并已确认商品信息无误，包装完好、没有划痕、没有破损等表面质量问题。国际件已消杀，做好内件防护。
          </div>
          <div style="margin-left: 8px; text-align: right; font-size: 8px; white-space: nowrap;">
            签收人/代签人： _________ <br/><br/>
            时间： _________
          </div>
        </div>
      </div>

      <!-- Barcode and Security Section -->
      <div style="border: 1px solid #000; margin-bottom: 6px; padding: 6px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="text-align: left;">
            <div style="font-size: 9px; margin-bottom: 1px;" >订单号：${item.order_number}</div>
            ${bottomBarcode}
          </div>
          <div style="display: flex; flex-direction: column; text-align: left; margin-left: -60px;">
            <div style="font-size: 16px; font-weight: bold; margin-top: 3px; margin-left: -60px;">已验视</div>
          </div>
        </div>
      </div>

      <!-- QR Code and Short Address Section -->
      <div style="border: 1px solid #000; margin-bottom: 4px; padding: 4px; display: flex; align-items: center; justify-content: center;">
        <div style="width: 90px; height: 90px; margin-right: 10px;">${qrCode}</div>
        <div style="flex-grow: 1; text-align: center;">
          <div style="font-size: 18px; font-weight: bold;">${item.dest_route_label || ''}</div>
          <div style="font-size: 20px; font-weight: bold;">${item.coding_mapping || ''}</div>
        </div>
      </div>

    </div>
  `;
  } catch (error) {
    console.error('Failed to generate label:', error);
    return null;
  }
};

export default generateLabel;
